import React, { useEffect } from 'react'

import { ErrorPage } from '@frame/components/screens/non-terminal/error'
import { Loading } from '@frame/components/screens/non-terminal/loading'
import { InternalEventType } from '@frame/lib/api/events/types'
import { ArgylePrepData, ConnectorId, DirectTask } from '@frame/lib/api/tasks/types'
import { useArgyleLink } from '@frame/lib/hooks/argyle/useArgyleLink'
import { useEventHandler } from '@frame/lib/hooks/useEventHandler'
import { DataAttribute } from '@frame/types'

type Props = {
  data: ArgylePrepData
  task: DirectTask
}

export function ArgyleScreen({ data, task }: Props) {
  const { linkInstance, loading, error } = useArgyleLink({ data, task })
  const { handleEvent } = useEventHandler()

  useEffect(() => {
    if (linkInstance) {
      // eslint-disable-next-line no-console
      console.log('Opening Argyle link instance')
      handleEvent(InternalEventType.BOOT_PARTNER_WIDGET, { partner_event: { name: ConnectorId.ARGYLE } })
      linkInstance.open()
    }
  }, [linkInstance, data, task])

  if (loading) {
    return <Loading />
  }

  if (error) {
    return <ErrorPage />
  }

  return <div data-cy={DataAttribute.PARTNER_SCREEN_ARGYLE} />
}
